{
  "newCampaign": "Nueva campaña",
  "firmware": {
    "update": {
      "label": "Actualización del firmware",
      "description": "Configurar la fecha y hora del procedimiento de activación de la actualización del firmware de {name}",
      "firmwareLabel": "Firmware",
      "uuidRequired": "El firmware es obligatorio",
      "plannedStartAt": "Fecha de actualización del firmware (DD/MM/YYYY HH:MM)",
      "notaBene": "La actualización del firmware se realizará durante la próxima comunicación con {name} a partir de la fecha de actualización del firmware.",
      "dateTimeError": "El campo de fecha es obligatorio para la actualización del firmware",
      "firmwareSelection": "Seleccione un firmware en la siguiente lista",
      "FirmwareSelectionRequired": "Debe seleccionar un firmware de la lista",
      "warningMessage": "Importante: actualizar el firmware implicará un reinicio de los equipos afectados al final de la actualización."
    }
  },
  "dateInferiorToToday": "La fecha no debe ser anterior a la fecha/hora actual",
  "dateInferiorToDate": "La fecha no debe ser anterior a {date}",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "confirm": "Confirmar",
  "cancel": "Cancelar",
  "list": {
    "column": {
      "name": {
        "label": "Campaña"
      },
      "type": {
        "label": "Tipo",
        "CRTCLT_RENEWAL_DVC": "Renovación de los certificados de los equipos",
        "CRTCLT_RENEWAL_APP": "Renovación de los certificados de las aplicaciones",
        "FIRMWARE_UPGRADE_DVC": "Actualización del firmware de los equipos"
      },
      "dates": {
        "label": "Fechas",
        "format": "DD/MM/YYYY"
      },
      "numberOfEquipments": {
        "label": "Número de equipos",
        "value": "{count} equipo | {count} equipo | {count} equipos"
      },
      "status": {
        "label": "Estado",
        "value": {
          "SCHEDULED": "Planificado",
          "RUNNING": "En curso",
          "PAUSED": "En pausa",
          "COMPLETE": "Finalizado",
          "COMPLETE_WITH_ERRORS": "Fallo",
          "INCOMPLETE": "Fallo",
          "PLATFORM_ERROR": "Error",
          "CANCELLING": "Cancelación",
          "CANCELLED": "Cancelada",
          "UNKNOWN": "Desconocido",
          "DRAFT": "Borrador"
        }
      },
      "pending": {
        "label": "En espera"
      },
      "inProgress": {
        "label": "En curso"
      },
      "success": {
        "label": "Éxito"
      },
      "failed": {
        "label": "Fracaso"
      },
      "numberOfDevice": {
        "label": "Número de equipos",
        "value": "{count} equipos | {count} equipo | {count} equipos"
      },
      "operations": "Operaciones",
      "done": {
        "label": "Realizado"
      }
    },
    "empty": "No se encontró ninguna campaña"
  },
  "details": {
    "buttons": {
      "update": {
        "label": "Modificar"
      },
      "cancel": {
        "label": "Cancelar la campaña",
        "confirm": {
          "message": "¿Confirmar la cancelación de la campaña?",
          "title": "Cancelar la campaña",
          "yes": "Sí",
          "no": "No"
        }
      },
      "edit": {
        "label": "Editar"
      }
    },
    "properties": {
      "title": "Propiedades",
      "name": {
        "label": "Nombre"
      },
      "type": {
        "label": "Tipo",
        "CRTCLT_RENEWAL_DVC": "Renovación de los certificados de los equipos",
        "CRTCLT_RENEWAL_APP": "Renovación de los certificados de las aplicaciones",
        "FIRMWARE_UPGRADE_DVC": "Actualización del firmware de los equipos"
      },
      "dates": {
        "label": "Fechas"
      },
      "state": {
        "label": "Estado"
      }
    },
    "characteristics": {
      "title": "Características",
      "createdBy": "Creado por",
      "type": {
        "label": "Tipo:",
        "value": {
          "CRTCLT_RENEWAL_DVC": "Renovación de los certificados de los equipos",
          "CRTCLT_RENEWAL_APP": "Renovación de los certificados de las aplicaciones",
          "FIRMWARE_UPGRADE_DVC": "Actualización del firmware de los equipos"
        }
      },
      "status": {
        "label": "Estado:",
        "value": {
          "SCHEDULED": "Planificado",
          "RUNNING": "En curso",
          "PAUSED": "En pausa",
          "COMPLETE": "Finalizado",
          "COMPLETE_WITH_ERRORS": "Fallo",
          "INCOMPLETE": "Fallo",
          "PLATFORM_ERROR": "Error",
          "CANCELLING": "Cancelación",
          "CANCELLED": "Cancelada"
        }
      },
      "lifeCyle": {
        "creation": "Creación: {value}",
        "launch": "Lanzamiento: {value}",
        "closing": "Cierre: {value}"
      },
      "inclusionPeriods": {
        "title": "Períodos de inclusión",
        "inactive": "inactivo",
        "monday": "Lunes: {value}",
        "tuesday": "Martes: {value}",
        "wednesday": "Miércoles: {value}",
        "thursday": "Jueves: {value}",
        "friday": "Viernes: {value}",
        "saturday": "Sábado: {value}",
        "sunday": "Domingo: {value}"
      },
      "equipments": {
        "title": "{count} equipo | {count} equipo | {count} equipos",
        "status": {
          "pending": "En espera: {percent}, {count} equipo | En espera: {percent}, {count} equipo | En espera: {percent}, {count} equipos",
          "running": "En curso: {percent}, {count} equipo | En curso: {percent}, {count} equipo | En curso: {percent}, {count} equipos",
          "complete": "Correcta: {percent}, {count} equipo | Correcta: {percent}, {count} equipo | Correcta: {percent}, {count} equipos",
          "failed": "Error: {percent}, {count} equipo | Error: {percent}, {count} equipo | Error: {percent}, {count} equipos"
        },
        "statistics": {
          "title": "{count} equipos | {count} equipo | {count} equipos"
        }
      },
      "devices": {
        "status": {
          "scheduled": "Programado: {percent}, {count} equipos | Programado: {percent}, {count} equipo | Programado: {percent}, {count} equipos",
          "completed": "Completado: {percent}, {count} equipos | Completado: {percent}, {count} equipo | Completado: {percent}, {count} equipos",
          "error": "Error: {percent}, {count} equipos | Error: {percent}, {count} equipo | Error: {percent}, {count} equipos",
          "running": "En curso: {percent}, {count} equipo | En curso: {percent}, {count} equipo | En curso: {percent}, {count} equipos"
        }
      },
      "operationType": "Tipo:"
    },
    "equipments": {
      "title": "Lista de equipos",
      "column": {
        "label": {
          "label": "Equipo"
        },
        "deviceType": {
          "label": "Tipo de equipo"
        },
        "message": {
          "label": "Estado de la operación"
        },
        "startDate": {
          "label": "Fecha de inicio de la operación",
          "format": "DD/MM/YYYY HH:mm"
        },
        "lastOperationDate": {
          "label": "Fecha de la última operación",
          "format": "DD/MM/YYYY HH:mm"
        },
        "name": {
          "label": "Nombre"
        },
        "serialNumber": {
          "label": "Número de serie"
        },
        "firmware": {
          "label": "Firmware"
        },
        "connectivity": {
          "label": "Conectividad"
        },
        "metastatus": {
          "label": "Metaestado"
        },
        "sector": {
          "label": "Sector"
        },
        "lastUpdate": {
          "label": "Fecha de la última actualización"
        },
        "operationStatus": {
          "label": "Estado de funcionamiento"
        }
      },
      "empty": "No se encontró ningún equipo",
      "states": {
        "WITHDRAWN": "Retirado",
        "DEACTIVATED": "Desactivado",
        "DELETED": "Eliminado"
      }
    },
    "status": {
      "title": "Estado de la campaña"
    },
    "cancel": {
      "error": "Se ha producido un error durante la cancelación de la campaña.",
      "success": "La cancelación de la campaña se ha activado correctamente."
    }
  },
  "form": {
    "campaignSettings": {
      "title": "Configuración de la campaña",
      "name": "Nombre de la campaña",
      "typeOfCampaign": {
        "title": "Tipo de la campaña",
        "firmwareUpdate": {
          "title": "Campaña de actualización del firmware",
          "option": "Actualización del firmware de los equipos",
          "label": "Nombre del firmware",
          "dependencies": "Dependencias"
        },
        "deviceCertificateRenewal": "Renovación de los certificados de los equipos",
        "applicationCertificateRenewal": "Renovación de los certificados de las aplicaciones"
      },
      "validation": {
        "name": "El nombre de la campaña es obligatorio",
        "type": "El tipo de la campaña es obligatorio",
        "firmwareUuid": "El firmware es obligatorio"
      }
    },
    "fleetSelection": {
      "title": "Selección de la flota de equipos",
      "devices": "Equipos",
      "applications": "Aplicaciones",
      "validation": {
        "required": "Es obligatorio seleccionar al menos un equipo"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Acciones en curso existentes",
            "message": "Algunos equipos seleccionados ya poseen acciones en curso. ¿Continuar?",
            "yes": "Sí",
            "no": "No"
          }
        }
      }
    },
    "campaignPlanification": {
      "title": "Planificación de la campaña",
      "executionDates": {
        "title": "Fechas de ejecución de la campaña",
        "plannedStartAt": "Inicio de la campaña",
        "endDate": "Fin de la campaña",
        "validation": {
          "plannedStartAt": "La fecha de inicio de la campaña es obligatoria",
          "plannedEndAt": "La fecha de fin de la campaña es obligatoria",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "La fecha de activación de la campaña no puede ser posterior a la de caducidad de la licencia",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "La fecha de fin de la campaña no puede ser posterior a la de caducidad de la licencia"
        }
      },
      "inclusionPeriods": {
        "title": "Períodos de inclusión",
        "remove": "Eliminar",
        "add": "Añadir",
        "day": "Día",
        "days": {
          "monday": "lunes",
          "tuesday": "martes",
          "wednesday": "miércoles",
          "thursday": "jueves",
          "friday": "viernes",
          "saturday": "sábado",
          "sunday": "domingo"
        },
        "validation": {
          "day": "El día del período de inclusión es obligatorio",
          "range": "La duración de un período de inclusión no puede ser inferior a 15 minutos"
        }
      }
    },
    "buttons": {
      "next": "Siguiente",
      "previous": "Anterior",
      "submit": "Validar"
    }
  },
  "report": {
    "title": "Informe",
    "plannedStartAt": "Fecha de activación prevista:",
    "processes": {
      "column": {
        "label": "Nombre",
        "status": "Estado"
      }
    }
  },
  "funnel": {
    "step": "Fase",
    "of": "de",
    "newCampaign": "Configurar una nueva campaña",
    "updateCampaign": "Editar la campaña",
    "scheduling": "Planificación",
    "next": "Siguiente",
    "previous": "Anterior",
    "publish": "Publicar la campaña",
    "campaignSettings": {
      "title": "Elegir los parámetros",
      "name": "Nombre de la campaña",
      "typeOfCampaign": {
        "title": "Tipo de campaña",
        "firmwareUpdate": {
          "label": "Actualización del firmware",
          "title": "Campaña de actualización del firmware",
          "firmwareName": "Nombre del firmware"
        },
        "certificate": "Certificado",
        "deviceCertificateRenewal": "Renovación de los certificados de los equipos",
        "applicationCertificateRenewal": "Renovación de los certificados de las aplicaciones",
        "configurationUpdate": {
          "selfSupporting": {
            "warningMessage": "Esta campaña se aplicará a la configuración más reciente que se ha cargado en cada uno de los dispositivos que ha seleccionado."
          }
        }
      },
      "validation": {
        "name": "El nombre de la campaña es obligatorio",
        "type": "El tipo de la campaña es obligatorio",
        "firmwareUuid": "El firmware es obligatorio"
      },
      "operationModelType": {
        "CONFIG": "Configuración",
        "FIRM_UPDATE": "Actualización de firmware",
        "OPTIONS": "Opciones",
        "CERT_RENEW": "Certificado"
      }
    },
    "fleetSelection": {
      "title": "Flota de equipos",
      "validation": {
        "required": "Es obligatorio seleccionar al menos un equipo"
      },
      "actions": {
        "scheduled": {
          "confirm": {
            "title": "Acciones en curso existentes",
            "message": "Algunos equipos seleccionados ya poseen acciones en curso. ¿Continuar?",
            "yes": "Sí",
            "no": "No"
          }
        }
      },
      "devices": "Equipos",
      "fleets": "Flotas",
      "fleetInformation": {
        "title": "Información de {fleetName}",
        "message": {
          "beginning": "Con la configuración de la campaña actual,",
          "middle": "{count} equipo en la flota | {count} equipo en la flota  | {count} equipos en la flota",
          "end": "no se puede actualizar | no se puede actualizar | no se podrá actualizar"
        }
      }
    },
    "campaignPlanification": {
      "title": "Elegir las fechas",
      "executionDates": {
        "plannedStartAt": "Inicio de la campaña",
        "endDate": "Fin de la campaña",
        "validation": {
          "plannedStartAt": "La fecha de inicio de la campaña es obligatoria",
          "startDateNotBeyondLicenseExpirationDateTolerancy": "La fecha de activación de la campaña no puede ser posterior a la de caducidad de la licencia",
          "endDateNotBeyondLicenseExpirationDateTolerancy": "La fecha de fin de la campaña no puede ser posterior a la de caducidad de la licencia",
          "plannedEndAt": "La fecha de fin de la campaña es obligatoria"
        }
      },
      "inclusionPeriods": {
        "title": "Períodos de inclusión",
        "subTitle": "Opcional",
        "informations": {
          "period": "Es un período durante el que un equipo tiene autorización para ejecutar una acción.",
          "defaultValue": "De forma predeterminada, no se aplicará ninguna restricción al equipo.",
          "businessHour": "Horario de oficina (de lunes a viernes: 9:00 a 18:00 h)",
          "weekendHour": "Fin de semana (sábado a domingo: 0:00 a 23:59 h)"
        },
        "days": {
          "monday": "lunes",
          "tuesday": "martes",
          "wednesday": "miércoles",
          "thursday": "jueves",
          "friday": "viernes",
          "saturday": "sábado",
          "sunday": "domingo"
        },
        "addADay": "Añadir un día",
        "add": "Añadir",
        "delete": "Eliminar",
        "selectPlaceholder": "Seleccionar un día",
        "start": "Inicio",
        "end": "Final",
        "validation": {
          "day": "El día del período de inclusión es obligatorio",
          "start": "El inicio del período de inclusión es obligatorio",
          "end": "El fin del período de inclusión es obligatorio",
          "range": "La duración de un período de inclusión no puede ser inferior a 15 minutos",
          "startAfterEnd": "La hora de inicio no puede ser posterior a la hora de finalización.",
          "endBeforeStart": "La hora de finalización no puede ser anterior a la hora de inicio."
        },
        "presets": {
          "businessHours": "Horario de atención (de lunes a viernes de 9:00 a 18:00)",
          "weekend": "Fin de semana (de sábado a domingo, de 12:00 a 23:59)"
        }
      }
    },
    "deviceFleetSelection": {
      "title": "Flota del equipo"
    }
  },
  "operationModelType": {
    "composite": "Compuesto"
  },
  "operationMgr": {
    "filters": {
      "status": "Estado",
      "type": "Tipo"
    }
  }
}
